// extracted by mini-css-extract-plugin
export var linkText = "_nh-0";